import { FC } from "react";
import {
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../redux/slices";

const Annotation: FC = () => {
  const [t] = useTranslation("global");
  const { sampleViewInfo } = useSelector(
    (state: State) => state.DataSampleViewReducer,
  );

  const labels = sampleViewInfo?.labels;
  const textsResults = sampleViewInfo?.texts;
  const finalAnnotations = labels
    ? Object.keys(labels).map((key) => {
        const labelData = labels[key];
        const displayName = textsResults?.[key] || key;
        return {
          key: key,
          name: displayName,
          data: labelData,
        };
      })
    : [];

  return (
    <div className="annotations">
      <div className="title-sections-sample-view">
        {t("Data.table.AnnotationName")}
      </div>
      <div className="annotation-container">
        {finalAnnotations.length >= 1 ? (
          <TableContainer component={Paper}>
            <Table
              size="small"
              sx={{ "& .MuiTableCell-root": { padding: "12px 16px" } }}
            >
              <TableBody>
                {finalAnnotations.map((labelInstances) => (
                  <TableRow key={labelInstances.key}>
                    <TableCell className="feat-content-annotation">
                      {labelInstances.name}
                    </TableCell>
                    <TableCell className="feat-content-annotation-value">
                      {labelInstances.data}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert severity="warning">
            {t("Data.SampleView.No_annotations")}
          </Alert>
        )}
      </div>
    </div>
  );
};

export default Annotation;
